async function request(path, options = {}) {
  const response = await fetch(path, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  const isJson = response.headers.get('content-type')?.includes('application/json');
  const body = isJson ? await response.json() : null;
  if (!response.ok) {
    const error = new Error(body?.detail || `Request failed: ${response.status}`);
    error.status = response.status;
    error.body = body;
    throw error;
  }
  return body;
}

export const profileApi = {
  get: () => request('/api/me/profile'),
  changePassword: (current_password, new_password) =>
    request('/api/me/password', {
      method: 'PUT',
      body: JSON.stringify({ current_password, new_password }),
    }),
  changeLanguage: (language_code) =>
    request('/api/me/preferred-language', {
      method: 'PUT',
      body: JSON.stringify({ language_code }),
    }),
  // 0.36.225 — Per-user IANA timezone.
  updateTimezone: (iana) =>
    request('/api/me/timezone', {
      method: 'PUT',
      body: JSON.stringify({ timezone: iana }),
    }),
  emailChangeStart: (new_email, current_password) =>
    request('/api/me/email-change/request', {
      method: 'POST',
      body: JSON.stringify({ new_email, current_password }),
    }),
  emailChangeVerify: (code) =>
    request('/api/me/email-change/verify', {
      method: 'POST',
      body: JSON.stringify({ code }),
    }),
  emailChangeCancel: () =>
    request('/api/me/email-change/cancel', { method: 'POST' }),
  helpdeskEmailChange: (new_email, reason) =>
    request('/api/me/email-change/helpdesk-request', {
      method: 'POST',
      body: JSON.stringify({ new_email, reason }),
    }),
  revokeOtherSessions: () =>
    request('/api/me/sessions/revoke-others', { method: 'POST' }),

  tfaStatus: () => request('/api/me/2fa/status'),
  tfaEnrollStart: () => request('/api/me/2fa/enroll/start', { method: 'POST' }),
  tfaEnrollVerify: (enrollment_token, code) =>
    request('/api/me/2fa/enroll/verify', {
      method: 'POST',
      body: JSON.stringify({ enrollment_token, code }),
    }),
  tfaDisable: (current_password) =>
    request('/api/me/2fa/disable', {
      method: 'POST',
      body: JSON.stringify({ current_password }),
    }),
  tfaListTrusted: () => request('/api/me/2fa/trusted-devices'),
  tfaRevokeTrusted: (device_id) =>
    request(`/api/me/2fa/trusted-devices/${device_id}`, { method: 'DELETE' }),
  tfaRevokeAllTrusted: () =>
    request('/api/me/2fa/trusted-devices/revoke-all', { method: 'POST' }),
};
